import React from 'react';
import { Button, Input, Select } from 'antd';

const ROLE_PRESETS = ['system', 'user', 'assistant', 'tool'];
const CUSTOM = '__custom__';

export const blankContextRow = () => ({
    role: 'system',
    content: '',
    roleMode: 'system',
    customRole: '',
});

export const toContextDraftRows = (messages) => {
    if (!Array.isArray(messages) || !messages.length) return [blankContextRow()];
    return messages.map((item) => {
        const role = String(item.role || 'system');
        const isPreset = ROLE_PRESETS.includes(role);
        return {
            role: isPreset ? role : role,
            content: String(item.content || ''),
            roleMode: isPreset ? role : CUSTOM,
            customRole: isPreset ? '' : role,
        };
    });
};

export const fromContextDraftRows = (rows) =>
    (rows || []).map((row) => ({
        role: row.roleMode === CUSTOM ? String(row.customRole || '').trim() : row.roleMode,
        content: String(row.content || '').trim(),
    }));

const ContextMessagesEditor = ({ value, onChange }) => {
    const rows = value?.length ? value : [blankContextRow()];

    const updateRow = (index, patch) => {
        onChange(rows.map((row, i) => (i === index ? { ...row, ...patch } : row)));
    };

    const moveRow = (index, direction) => {
        const nextIndex = index + direction;
        if (nextIndex < 0 || nextIndex >= rows.length) return;
        const next = [...rows];
        [next[index], next[nextIndex]] = [next[nextIndex], next[index]];
        onChange(next);
    };

    const removeRow = (index) => {
        onChange(rows.length <= 1 ? [blankContextRow()] : rows.filter((_, i) => i !== index));
    };

    return (
        <div className="space-y-3">
            {rows.map((row, index) => (
                <div key={index} className="rounded-xl border border-[#e4e7ec] p-3">
                    <div className="mb-2 flex flex-wrap items-center gap-2">
                        <Select
                            style={{ minWidth: 140 }}
                            value={row.roleMode}
                            onChange={(next) => {
                                if (next === CUSTOM) {
                                    updateRow(index, {
                                        roleMode: CUSTOM,
                                        customRole: row.customRole || '',
                                    });
                                } else {
                                    updateRow(index, { roleMode: next, role: next });
                                }
                            }}
                            options={[
                                ...ROLE_PRESETS.map((role) => ({
                                    value: role,
                                    label: role,
                                })),
                                { value: CUSTOM, label: 'Своя…' },
                            ]}
                        />
                        {row.roleMode === CUSTOM ? (
                            <Input
                                style={{ maxWidth: 160 }}
                                placeholder="role"
                                value={row.customRole}
                                onChange={(event) =>
                                    updateRow(index, { customRole: event.target.value })
                                }
                            />
                        ) : null}
                        <div className="ml-auto flex gap-1">
                            <Button
                                size="small"
                                onClick={() => moveRow(index, -1)}
                                disabled={index === 0}
                            >
                                ↑
                            </Button>
                            <Button
                                size="small"
                                onClick={() => moveRow(index, 1)}
                                disabled={index === rows.length - 1}
                            >
                                ↓
                            </Button>
                            <Button size="small" danger onClick={() => removeRow(index)}>
                                Удалить
                            </Button>
                        </div>
                    </div>
                    <Input.TextArea
                        rows={3}
                        placeholder="content"
                        value={row.content}
                        onChange={(event) =>
                            updateRow(index, { content: event.target.value })
                        }
                    />
                </div>
            ))}
            <Button
                type="dashed"
                block
                onClick={() => onChange([...rows, blankContextRow()])}
            >
                + Добавить сообщение
            </Button>
        </div>
    );
};

export default ContextMessagesEditor;
